// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-bookmark-button {
    position: absolute;
    top: calc(3rem - 8px);
    right: 2rem;
}

@media (max-width: 992px) {
    .custom-bookmark-button {
        top: 1.5rem;
        right: 0;
    }
}

@media (max-width: 700px) {
    .custom-bookmark-button {
        top: 1.5rem;
        right: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/customBookmark/CustomBookmark.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,WAAW;QACX,QAAQ;IACZ;AACJ","sourcesContent":[".custom-bookmark-button {\n    position: absolute;\n    top: calc(3rem - 8px);\n    right: 2rem;\n}\n\n@media (max-width: 992px) {\n    .custom-bookmark-button {\n        top: 1.5rem;\n        right: 0;\n    }\n}\n\n@media (max-width: 700px) {\n    .custom-bookmark-button {\n        top: 1.5rem;\n        right: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
